import { identifierForGlobKey } from "stimulus-vite-helpers"

const registry = new Map()
const loading = new Map()
const registered = new Set()
let observer

function identifiersFromElement(element) {
  const value = element.getAttribute("data-controller")
  if (!value) return []

  return value
    .split(/\s+/)
    .map((item) => item.trim())
    .filter(Boolean)
}

function elementsWithControllers(root) {
  if (!(root instanceof Element || root instanceof Document || root instanceof DocumentFragment)) {
    return []
  }

  const elements = []
  if (root instanceof Element && root.hasAttribute("data-controller")) {
    elements.push(root)
  }

  root.querySelectorAll?.("[data-controller]").forEach((node) => elements.push(node))
  return elements
}

async function loadController(application, identifier) {
  if (registered.has(identifier)) return
  if (loading.has(identifier)) return loading.get(identifier)

  const loader = registry.get(identifier)
  if (!loader) return

  const promise = loader()
    .then((module) => {
      const constructor = module.default ?? module
      if (typeof constructor === "function") {
        application.register(identifier, constructor)
        registered.add(identifier)
      }
    })
    .finally(() => {
      loading.delete(identifier)
    })

  loading.set(identifier, promise)
  return promise
}

function scanAndLoad(application, root = document) {
  const identifiers = new Set()

  elementsWithControllers(root).forEach((element) => {
    identifiersFromElement(element).forEach((identifier) => identifiers.add(identifier))
  })

  identifiers.forEach((identifier) => {
    void loadController(application, identifier)
  })
}

function ensureObserver(application) {
  if (observer) return

  observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.attributeName === "data-controller") {
        scanAndLoad(application, mutation.target)
      }

      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
          scanAndLoad(application, node)
        })
      }
    })
  })

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-controller"],
    childList: true,
    subtree: true
  })
}

export function registerLazyControllers(application, controllerModules) {
  Object.entries(controllerModules).forEach(([path, loader]) => {
    const identifier = identifierForGlobKey(path)
    if (identifier) registry.set(identifier, loader)
  })

  ensureObserver(application)
  scanAndLoad(application)
}
